import request from '@/utils/request'

// 采购单位(3)可见价格
export function getPurchaseVisiblePrices() {
  return request({
    url: '/sys-config/purchase-visible-prices',
    method: 'get'
  })
}
export function savePurchaseVisiblePrices(data) {
  return request({
    url: '/sys-config/purchase-visible-prices',
    method: 'post',
    data
  })
}

// 教育局(5)可见价格
export function getEduVisiblePrices() {
  return request({
    url: '/sys-config/edu-visible-prices',
    method: 'get'
  })
}
export function saveEduVisiblePrices(data) {
  return request({
    url: '/sys-config/edu-visible-prices',
    method: 'post',
    data
  })
}
